$(document).ready(function() {

	// search box
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm('monthly');
	}

	// open/close faqs
	if ($('.pnw-faq').length > 0) {
		$('.pnw-faq-question').on('click', function() {
			$(this).parent().toggleClass('pnw-faq-active');
		});
	}

	// contact form
	// $('#pnw-contact-form').validate({
	// 	// debug: true,
	// 	errorElement: 'span',
	// 	errorClass: 'form-field-error',
	// 	validClass: 'form-field-valid',
	// 	errorPlacement: function (error, element) {
	// 		error.appendTo(element.parents('.form-field'));
	// 	},
	// 	highlight: function (element, errorClass, validClass) {
	// 		$(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
	// 	},
	// 	unhighlight: function (element, errorClass, validClass) {
	// 		$(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
	// 	},
	// 	rules: {
	// 		'name': {
	// 			required: true,
	// 			minlength: 2
	// 		},
	// 		'email': {
	// 			required: true,
	// 			email: true
	// 		},
	// 		'subject': {
	// 			required: true
	// 		},
	// 		'message': {
	// 			required: true,
	// 			minlength: 2
	// 		}
	// 	},
	// 	messages: {
	// 		'name': {
	// 			required: 'Please enter your name.',
	// 			minlength: 'Your name must be at least 2 characters long.'
	// 		},
	// 		'email': {
	// 			required: 'Please enter your email address.',
	// 			email: 'Please enter a valid email address.'
	// 		},
	// 		'subject': {
	// 			required: 'Please choose a subject.'
	// 		},
	// 		'message': {
	// 			required: 'Please explain how we can help you.',
	// 			minlength: 'Your message must be at least 2 characters long.'
	// 		}
	// 	},
	// 	submitHandler: function(form) {
	//
	// 		$('.button-spinner').prop('disabled', true);
	//
	// 		var name = $('#name').val();
	// 		var email = $('#email').val();
	// 		var subject = $('#subject').val();
	// 		var message = $('#message').val();
	// 		var nonce = $('#pnw-contact-form-nonce').val();
	//
	// 		$.ajax({
	// 			type: 'post',
	// 			url: '/wp-admin/admin-ajax.php',
	// 			data: {
	// 				action: 'pnw_contact_form',
	// 				name: name,
	// 				email: email,
	// 				subject: subject,
	// 				message: message,
	// 				nonce: nonce
	// 			},
	// 			success: function(results) {
	// 				var results = JSON.parse(results);
	// 				console.log(results);
	// 				if (results.status === 'success') {
	// 					// it worked!
	// 					$('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
	// 				} else if (results.status === 'error') {
	// 					// it didn't work?
	// 					$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
	// 				} else {
	// 					// something else happened
	// 					$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong? Please try again.');
	// 				}
	// 				$('.button-spinner').prop('disabled', false);
	// 			},
	// 			error: function(results) {
	// 				var results = JSON.parse(results);
	// 				console.log(results);
	// 				$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Something went wrong? Please try again.');
	// 				$('.button-spinner').prop('disabled', false);
	// 			}
	// 		});
	// 	}
	// });

});
